import Link from 'next/link';

import {
  NavigationButtonWrapperQuiz,
  QuizLayout,
} from '@components/Quiz/PageWrapperQuiz';
import { DepthEffectButton } from '@components/NhsSignup/ui';
import { QuizPrimer } from '@components/Quiz/Screens/QuizPrimer';
import { useStartQuiz } from '@hooks/quizHooks';

const Index = (): JSX.Element => {
  useStartQuiz();

  return (
    <>
      <div className="mb-8">
        <QuizPrimer />
      </div>
      <div className="lg:mt-10">
        <NavigationButtonWrapperQuiz>
          <Link href="/us/get-plan/priorities">
            <DepthEffectButton data-cy="glp1-quiz-primer">
              Get started
            </DepthEffectButton>
          </Link>
        </NavigationButtonWrapperQuiz>
      </div>
    </>
  );
};

Index.getLayout = QuizLayout;

export default Index;
